<template>
    <div class="component__view">
        <div class="title"></div>

        <div class="m-ticket">
            <div class="ticket-view">
                <div class="u-btn invite" v-if="invite_data.length < 3" @click="call_invite()"></div>
                <div class="u-btn apply" v-else-if="invite_data.length >= 3 && !buff" @click="call_invite()"></div>
                <!-- <div class="u-btn apply dismiss" @click="call_invite()" v-else-if="invite_data.length >= 3 && buff"></div> -->
                 <div class="u-btn apply dismiss" @click="call_invite()" v-else-if="invite_data.length >= 3 && buff"></div>
            </div>
        </div>
        
        <div class="m-shop">
            <div class="shop-pannel">

                <div class="banner b-1"></div>
                <div class="vip-view">
                    <div class="goods-view">
                        <div class="item-name">{{ vip_data.giftName }}X{{ vip_data.sendNum }}</div>
                        <div class="reward-pic" v-tips="vip_data.giftId"><game-item :locked="true" :id="vip_data.giftId" :num="-1"></game-item></div>

                        <div class="price flex-between-end">
                            <div class="before-price flex-wrap">
                                <div class="icon-before"></div>
                                <div class="amt">{{ get_amt(vip_data) }}</div>
                            </div>
                            <div class="now-price">{{ buff ? vip_data.amt1 : vip_data.amt2 }}</div>
                        </div>

                        <div class="u-btn apply goods dismiss" v-if="vip_data.buyCount">已购买</div>
                        <div class="u-btn apply goods disabled" v-else-if="in_basket(vip_data)">已加入</div>
                        <div class="u-btn apply goods" v-else @click="add_to_cart(vip_data)">加入购物车</div>                        

                    </div>
                </div>


                <div class="banner b-2"></div>
                <div class="shop-view">
                    <vuescroll>
                        <div class="shop-list flex-start-start flex-wrap">
                            <div class="shop-item" v-for="(item,index) in common_list" :key="item.id">
                                <div class="reward-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="-1"></game-item></div>

                                <div class="item-name">{{ item.giftName }}</div>
                                <div class="item-cnt">X{{ item.sendNum }}</div>

                                <div class="price flex-between-end">
                                    <div class="before-price flex-wrap">
                                        <div class="icon-before"></div>
                                        <div class="amt">{{ get_amt(item) }}</div>
                                    </div>
                                    <div class="now-price">{{ buff ? item.amt1 : item.amt2 }}</div>
                                </div>

                                <div class="u-btn apply goods dismiss" v-if="item.buyCount">已购买</div>
                                <div class="u-btn apply goods disabled" v-else-if="in_basket(item)">已加入</div>
                                <div class="u-btn apply goods" v-else @click="add_to_cart(item)">加入购物车</div>
                            </div>
                        </div>
                    </vuescroll>
                </div>
            </div>
        </div>

        <div class="basket-cntor"  :class="{'ios' : $global.isIos , 'kd' : KD.isApp() ,'ios-26' : $global.getIOSVersion() >= 18.7 , 'ios-d' : $global.isDynamicIsland()}" v-show="!popup" >
            <div class="cntor-wrapper flex-start-center">

                <div class="cntor cart" id="buycar" @click="popup_show ()">
                    <div class="cnt">{{ cart_list.length }}</div>
                </div>

                <div class="total">
                    <div class="total-before">狂欢价：{{ totalSum }}</div>
                    <div class="notice">使用8折券后抵扣{{ totalSum - totalBuff }}</div>
                </div>

                <div class="cost-info">
                    <div>合计 <em class="icon-m3b"></em> <span class="cost">{{ buff ? totalBuff : totalSum }}</span></div>
                </div>

                <div class="u-btn primary" @click="popup_show ()"></div>
            </div>  
        </div>

        <div class="basket-detail-view vue-popup" v-show="popup">
            <transition name="van-slide-up">            
            <div class="basket-detail popup-content"  :class="{'ios' : $global.isIos , 'kd' : KD.isApp() ,'ios-26' : $global.getIOSVersion() >= 18.7 , 'ios-d' : $global.isDynamicIsland()}" v-show="popup">
                <div class="popup-header">
                    <div class="uis flex-between-center">
                        <div class="u-btn back" @click="popup = popup_close ()"></div>
                        <div class="u-btn close" @click="popup = popup_close ()"></div>
                    </div>
                </div>


                <div class="list-view" :style="{'height' : cart_list.length > 5 ? '700px' : 'auto'}">
                    <vuescroll>
                        <div class="goods-list">
                            <div class="list-item" v-for="(item,index) in cart_list" :key="item.id">

                                <van-swipe-cell>
                                    <div class="list-content flex-start-center">
                                        <div class="reward-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>

                                        <div class="goods-info">
                                            <div class="item-name">{{ item.giftName }}</div>
                                            <div class="price flex-start-center">
                                                <div class="now-price"><em class="icon-fever"></em>{{ buff ? item.amt1 : item.amt2 }}<em class="icon-m3b"></em></div>
                                                <div class="show-price flex-start-center">
                                                    <em class="icon-before"></em><div class="before-price">{{ get_amt(item) }}</div>
                                                </div>                                           
                                            </div>
                                        </div>

                                        <div class="u-btn del" @click="delete_item(item)"></div>
                                    </div>
                                    <template #right>
                                        <div class="u-btn bas-del" @click="delete_item(item)">移出</div>
                                    </template>
                                </van-swipe-cell>

                            </div>
                        </div>
                    </vuescroll>
                </div>

                <div class="total-price-view">
                    <div class="price-detail">
                        <div class="price-item">
                            <div class="label">商品原价</div>
                            <div class="amt" style="color: #4c4c4c;">{{ totalBefore }}<em class="icon-m3b"></em></div>
                        </div>
                        <div class="price-item">
                            <div class="label">百亿补贴抵扣</div>
                            <div class="amt" style="color: #ea593f;">{{ totalSum - totalBefore }}<em class="icon-m3b"></em></div>
                        </div>
                        <div class="price-item">
                            <div class="label">使用8折券后抵扣</div>
                            <div class="amt" style="color: #ea593f;" v-if="buff">{{ totalSum - totalBuff }}<em class="icon-m3b"></em></div>
                            <div class="notice u-btn" v-else @click="popup_close ();call_invite()">领取折扣券</div>
                        </div>
                    </div>

                    <div class="price-result flex-between-start">
                        <div class="goods-cnt">共{{ cart_list.length }}件</div>
                        <div class="total-price" >合计：<span style="color: #ea593f;font-size: 28px;">{{ buff ? totalBuff : totalSum }}</span><em class="icon-m3b"></em></div>
                    </div>
                </div>

                <div class="user-ctrl">
                    <div class="u-btn buy" @click="call_cart_submit()"></div>
                </div>
                
            </div>
            </transition>  
            <div class="u-mask" @click="popup = popup_close ()"></div>
        </div>

    </div>
</template>

<script>
import {
    apiShopList,
    apiAddCart,
    apiDelCart,
    apiCartList,
    apiInviteList,
    apiInviteCode,
    apiGetBuff,
    apiBuffList,  
} from '@/api/index';

import goods_dic from '@/components/goodsdic.js';//仅做显示原价用

import KD from '@/assets/js/kd.js';

export default {
    data(){
        return {
            popup : false,
            ball: {
                show: false, //是否显示小球
                el: "",//获取小球的dom
                x : 0,
                y : 0,
            },
            config : {},
            shop_list : [],
            common_list : [],
            cart_list : [],
            invite_data : [],
            goods_dic : goods_dic.list,
            buff : false,
            vip : 'JM05',
            vip_data : {},
            KD,
        }
    },
    computed :{
        _zid (){
            return this.$store.state.userinfo.zid;
        },
        totalSum() {
            return this.cart_list.reduce((sum, goods) => sum + goods.amt2, 0);
        },      
        totalBuff() {
            return this.cart_list.reduce((sum, goods) => sum + goods.amt1, 0);
        },
        totalBefore() {
            return this.cart_list.reduce((sum, goods) => sum + parseInt(this.get_amt(goods)), 0);
        },
        _list (){
            return this.$store.state.list;
        },
        _buff (){
            return this.$store.state.buff;
        },           
    },
    watch : {
        _zid : {
            handler(newVal, oldVal) {
                if(newVal != oldVal){
                    this.score_list = newVal;
                }              
            },
            deep: true
        },
        _list : {
            handler(newVal, oldVal) {
                if(newVal != oldVal){
                    this.shop_list = newVal;
                    //todo
                    if(this.$store.state.userinfo.zid)this.get_cart_info();                   
                }              
            },
            deep: true
        },
        _buff : {
            handler(newVal, oldVal) {
                if(newVal != oldVal){
                    // this.init();
                    this.buff = newVal;
                }              
            },           
        }                                        
    },     
    mounted(){
        this.init();
        if(!this.$store.state.userinfo.zid)return;
        //this.get_cart_info();
        this.invite_list ();

        //test
        //this.$msg_modal({ text : '恭喜您获得双11分享礼，助力包已发送至军师邮件，请注意查收，本次活动【百亿补贴】中所有商品全部八折！！' , fromType : 1});
    },
    methods : {
        init(){
            apiShopList().then(
                res => {
                    this.shop_list = res.data;
                    this.common_list = res.data.filter( ele => ele.giftId != this.vip );
                    this.vip_data = res.data.filter( ele => ele.giftId == this.vip )[0];
                    
                    this.buff = res.message == 'True';
                    this.$store.commit("$_setList", res.data);
                    this.$store.commit("$_setBuff", this.buff);
                },
            )
        },
        get_cart_info (){
            apiCartList().then(
                res => {
                    this.cart_list = res.data;
                },                
            )
        },
        get_amt(item){
            let ret = this.goods_dic.filter( ele => ele.goodsId == item.giftId && ele.sendNum == item.sendNum );
            return ret.length ? ret[0].amt : 0;
        },
        put_in(item){
            this.in_basket(item) ? '' : this.cart_list.push(item);            
        },
        delete_item(item){

            apiDelCart({ id : item.id }).then(
                res => {
                    let index = this.cart_list.findIndex(ele => item.id == ele.id);
                    this.cart_list.splice(index, 1);                    
                    this.$toast('移出成功~');
                },
                rej => {
                    this.$toast(res.message);
                }
            )
        },
        in_basket(item){
            //todo
            let index = this.cart_list.findIndex(ele => item.id == ele.id);
            return index != -1;
        },        
        add_to_cart(item){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            // 显示小球
            this.ball.show = true;
            // 获取点击元素
            this.ball.el = event.target;

            this.put_in(item);

            //todo
            apiAddCart({ id : item.id }).then(
                res => {
                    this.$toast('加入购物车成功~');
                },
                rej => {
                    this.$toast(rej.message);
                }
            )
        },
        popup_show (){
            document.body.style.overflow = 'hidden';
            this.popup = true;
        },
        popup_close (){
            document.body.style.overflow = '';
            this.popup = false;
        },
        get_buff(){
            apiGetBuff().then(
                res => {
                    this.buff = true;
                    this.$store.commit("$_setBuff", this.buff);
                    this.$toast('获取补贴成功~');
                    this.$msg_modal({ text : '恭喜您获得双11分享礼，助力包已发送至军师邮件，请注意查收，本次活动【百亿补贴】中所有商品全部八折！！' , fromType : 1});
                },
                rej => {
                    this.$toast(rej.message);
                }
            )
        },
        invite_list (){
            apiBuffList().then(
                res => {
                    this.invite_data = res.data.list;
                }
            )
        },
        call_invite(){
            if(!this.$store.state.login){
                return this.$mslogin.login();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }
            
            apiInviteCode({mode : 2}).then(
                res => {
                    let shareTxt = res.data.koudai  ? (res.data.koudai + res.data.url) : res.data.url; 
                    this.$invite_modal({ shareTxt : shareTxt , friend_list : this.invite_data , buff : this.buff});                   
                },
                rej => {
                    this.$toast(rej.message)
                }
            )
        },
        call_cart_submit(){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }
            if(!this.$store.state.userinfo.zid){
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.popup_close();

            this.$comfirmwarn({ cost : this.buff ? this.totalBuff : this.totalSum , list : this.cart_list , buff : this.buff ,friend_list : this.invite_data ,})
        },
    },
}
</script>

<style lang="scss" scoped>
.component__view{
    width: 750px;
    height: 1879px;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center top;
    box-sizing: border-box;
    background-image: url(~@/assets/images/shop/body.jpg);    
}

.title{
    width: 711px;
    height: 229px;
    margin: 0 auto 30px;
    background-image: url(~@/assets/images/shop/title.png); 
}

.m-ticket{
    margin-bottom: 20px;

    .ticket-view{
        position: relative;
        width: 665px;
        height: 159px;
        margin: 0 auto;
        background-image: url(~@/assets/images/shop/ticket.png); 
    }

    .u-btn.invite{
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-39%);
        width: 104px;
        height: 108px;
        background-image: url(~@/assets/images/shop/btn-share.png); 
    }

    .u-btn.apply{
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-39%);
        width: 104px;
        height: 108px;
        background-image: url(~@/assets/images/shop/btn-apply.png); 
    }

}

.ball-box {
  .ball {
    position: fixed;
    bottom: 0;
    left: 50%;
    margin-left: -300px;
    z-index: 20;
    color: #f00;
    transition: all 1s cubic-bezier(0.49, -0.29, 0.75, 0.41);

    .inner {
      transition: all 1s linear;
    }

    .ball-shape{
        width: 40px;
        height: 40px;
        background-color: #e8533d;
        border-radius: 50%;
    }
  }
}

.shop-pannel{
    width: 750px;
    height: 1880px;
    margin: 0 auto;
    padding-top: 40px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/shop/pannel.png);

    .banner{
        width: 606px;
        height: 53px;
        margin: 0 auto 20px;

        &.b-1{
            background-image: url(~@/assets/images/shop/shop-banner_1.png);
        }

        &.b-2{
            background-image: url(~@/assets/images/shop/shop-banner_2.png);
        }
    }

    .vip-view{
        position: relative;
        width: 661px;
        height: 361px;
        margin: 0 auto 20px;
        background-image: url(~@/assets/images/shop/bg-item_vip.png);

        .goods-view{
            padding-top: 20px;
        }

        .item-name{
            font-size: 28px;
            font-weight: 700;
            color: #4c4c4c;
        }

        .reward-pic{
            width: 69px;
            height: 69px;
            margin: 30px auto 0;
        }

        .price{
            padding: 0 130px;
        }

        .u-btn.apply{
            position: absolute;
            left: 50%;
            bottom: 20px;
            transform: translateX(-50%);
            width: 312px;
            height: 76px;
            line-height: 76px;
            text-align: center;
            color: #fef6db;
            background-color: #ef6b4a;
            border-radius: 12px;
        }        

    }

    .shop-view{
        padding: 0 16px 0 30px;
        height: 640px;
    }

    .shop-item{
        position: relative;
        width: 321px;
        height: 360px;
        margin: 0 13px 26px;
        padding-top: 38px;
        box-sizing: border-box;
        background-image: url(~@/assets/images/shop/shop-item.png);

        .u-btn.apply{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 76px;
            line-height: 76px;
            text-align: center;
            color: #fef6db;
            background-color: #ef6b4a;
            border-radius: 0 0 12px 12px;
        }
    }

    .reward-pic{
        width: 69px;
        height: 69px;
        margin: 0 auto 16px;
    }

    .item-name{
        font-size: 28px;
        color: #4c4c4c;
        text-align: center;
    }

    .item-cnt{
        font-size: 22px;
        font-weight: 700;
        color: #6a6a6a;
        text-align: center;
    }

    .price{
        position: relative;
        margin-top: 16px;
        padding: 0 20px;
    }

    .before-price{
        position: relative;

        &::after{
            content: '狂欢价';
            display: block;
            position: absolute;
            top: -30px;
            left: 2px;
            font-weight: 700;
            color: #e8533d;
        }

        .icon-before{
            width: 48px;
            height: 25px;
            margin-right: 8px;
            background-image: url(~@/assets/images/shop/icon-price.png);
        }

        .amt{
            position: relative;
            font-size: 22px;
            color: #adadad;

            &::after{
                content: '';
                display: block;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                width: 60px;
                height: 7px;
                background-image: url(~@/assets/images/shop/line.png);
            }
        }
    }

    .now-price{
        font-size: 68px;
        color: #e8533d;
        font-family: 'spNum';
    }
}

.basket-cntor {
    position: fixed;
    width: 750px;
    height: 239px;
    padding: 55px 15px 0 25px;
    left: 50%;
    bottom: 0;
    z-index: 5;
    box-sizing: border-box;
    transform: translateX(-50%); 
    background-image: url(~@/assets/images/shop/bg-basket.png);

    &.ios-d.kd { bottom: 50px; }

    .cntor-wrapper{
        position: relative;
        height: 66px;
    }

    .cntor{
        position: relative;
        width: 64px;
        height: 53px;
        margin-right: 20px;
        background-image: url(~@/assets/images/shop/basket-cnt.png);

        .cnt{
            position: absolute;
            top: 0;
            right: 5px;
            font-size: 20px;
            color: #fcf9f2;
        }
    }

    .total{
        margin-right: 45px;
        font-size: 20px;
        color: #999999;
    }

    .cost-info{
        color: #4c4c4c;
        .cost{
            font-size: 36px;
            color: #ec6748;
        }
    }

    .u-btn.primary{
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -33px;
        width: 170px;
        height: 66px;
        background-image: url(~@/assets/images/shop/btn-primary.png);
    }
}

.vue-popup {
    .popup-content {
        position: fixed;
        min-height: 400px;
        bottom: 0;
        left: 50%;
        width: 750px;
        margin-left: -375px;
        -webkit-transition: all 0.2s ease-in;
        transition: all 0.2s ease-in;
        z-index: 1000;

        &.ios-d.kd { bottom: 50px; }

        p {
            line-height: 30px;
            text-align: center;
        }
    }
}

.basket-detail{
    padding: 26px 0;
    background-color: #fdf6eb;
    border-radius: 10px 10px 0 0;

    .uis{
        margin: 0 10px;
        padding: 0 0 20px;
        border-bottom: 1px solid #f9d5c8;
    }

    .u-btn.back{
        width: 18px;
        height: 26px;
        background-image: url(~@/assets/images/shop/btn-back.png);
    }

    .u-btn.close{
        width: 22px;
        height: 22px;
        background-image: url(~@/assets/images/shop/btn-close.png);
    }

    .list-view{
        padding-left: 5px;
        // height: 700px;
    }
    
    .goods-list{
        margin-top: 10px;

        .list-item{
            margin:  0 auto 10px;
        }

        .bas-del{
            position: relative;
            top: 50%;
            width: 66px;
            height: 66px;
            line-height: 66px;
            text-align: center;
            background-color: #e8533d;
            border-radius: 50%;
            color: #fff;
            margin-top: -33px;
            margin-right: 40px;
            // background-image: url(~@/assets/images/shop/btn-del.png);
        }

        .list-content{
            position: relative;
            width: 735px;           
            padding: 22px 0 22px 40px;
            box-sizing: border-box;
            background-color: #fffcf2;
            border: 1px solid #f9d5c8;
            border-radius: 10px;
        }

        .u-btn.del{
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
            width: 26px;
            height: 28px;
            background-image: url(~@/assets/images/shop/btn-del.png);
        }

        .reward-pic{
            width: 69px;
            height: 69px;
        }

        .goods-info{
            margin-left: 18px;
        }

        .item-name{
            margin-bottom: 18px;
            font-size: 22px;
            font-weight: 700;
            color: #4c4c4c;
        }

        .icon-fever{
            display: inline-block;
            width: 56px;
            height: 21px;
            background-image: url(~@/assets/images/shop/icon-fever.png);
        }

        .icon-before{
            display: inline-block;
            width: 48px;
            height: 23px;
            background-image: url(~@/assets/images/shop/icon-before.png);
        }        

        .price{
            .now-price{
                margin-right: 18px;
                font-size: 30px;
                color: #e8533d;
            }

            .before-price{
                position: relative;
                font-size: 22px;
                color: #adadad;

                &::after{
                    content: '';
                    display: block;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%,-50%);
                    width: 60px;
                    height: 3px;
                    background-image: url(~@/assets/images/shop/line_2.png);
                }
            }

        }
    }

    .total-price-view{
        width: 735px;
        margin: 0 auto 10px;
        padding: 22px 40px 22px 40px;
        box-sizing: border-box;
        background-color: #fffcf2;
        border: 1px solid #f9d5c8;
        border-radius: 10px;        
    }

    .price-detail{
        border-bottom: 1px solid #f9d5c8;

        .price-item{
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
        }

        .label{
            color: #4c4c4c;
        }

        .notice{
            color: #ea593f;
        }
    }

    .price-result{
        margin-top: 20px;
        color: #4c4c4c;
    }

    .user-ctrl{
        clear: both;
        overflow: hidden;
        width: 735px;
        margin: 0 auto;
    }

    .u-btn.buy{
        float: right;
        width: 240px;
        height: 66px;
        background-image: url(~@/assets/images/shop/btn-buy.png);
    }
}

/* 按常见 iPhone 机型尺寸/像素比做覆盖（仅作兜底，不保证所有 WebView 都准确） */
/* iPhone 14 Pro / 13 Pro / 12 Pro (CSS 尺寸 393x852, DPR 3) */
@media only screen and (orientation: portrait) and (device-width: 393px) and (device-height: 852px) and (-webkit-device-pixel-ratio: 3) {
.basket-cntor.ios-d.kd { bottom: 50px; }
.popup-content.ios-d.kd { bottom: 50px; }
}

/* iPhone 14 Pro Max / 13 Pro Max / 12 Pro Max (428x926, DPR 3) */
@media only screen and (orientation: portrait) and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {
.basket-cntor.ios-d.kd { bottom: 50px; }
.popup-content.ios-d.kd { bottom: 50px; }
}

/* iPhone 12/13/14 / 12/13/14 mini 常见非 Pro 小刘海 (390x844, DPR 3) */
@media only screen and (orientation: portrait) and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) {
.basket-cntor.ios-d.kd { bottom: 40px; }
.popup-content.ios-d.kd { bottom: 40px; }
}

/* iPhone X / XS / 11 Pro (375x812, DPR 3) */
@media only screen and (orientation: portrait) and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
.basket-cntor.ios-d.kd { bottom: 40px; }
.popup-content.ios-d.kd { bottom: 40px; }
}

/* iPhone XR / 11 (414x896, DPR 2) */
@media only screen and (orientation: portrait) and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
.basket-cntor.ios-d.kd { bottom: 40px; }
.popup-content.ios-d.kd { bottom: 40px; }
}
</style>